export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiki"])},
  "shortcut-count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["1 raccourci"]), _normalize([_interpolate(_named("count")), " raccourcis"])])},
  "command-count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["1 commande"]), _normalize([_interpolate(_named("count")), " commandes"])])},
  "pages": [
    {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Affectation des touches"])},
      "route": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["keyboard"])},
      "icon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mdi-keyboard"])}
    },
    {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commandes"])},
      "route": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["commands"])},
      "icon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mdi-slash-forward"])}
    },
    {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crime Minigames"])},
      "route": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["crimeminigames"])},
      "icon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mdi-controller"])}
    }
  ],
  "keys": {
    "mouse-right": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clic droit"])}
  },
  "keyboard": {
    "shortcuts": [
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shift"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mouse-right"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Interaction avec les joueurs, les véhicules, les portes et les poubelles"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["F12"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Changer de personnage"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Démarrage du moteur"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouverture et fermeture à distance du véhicule"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["R"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recharger l'arme"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Y"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retirer le chargeur de l'arme"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["B"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Changer le mode de tir des armes"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Z"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["S'allonger"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NUMPAD 1-9"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animations telles que l'agitation, les mains tendues et les mains levées"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roue d'animation ouverte"])}
      },
      {
        "Keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["X"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Régler le volume de la voix"])}
      }
    ]
  },
  "commands": {
    "/l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour au lobby"])},
    "/unverify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déverifier votre identité Teamspeak"])},
    "/log": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer un journal dans le RP pour signaler les autres joueurs"])},
    "/account-verify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reliez votre compte de site web à votre compte Minecraft"])},
    "/discord-verify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Liez votre compte Discord à votre compte Minecraft."])},
    "/discord-unlink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déconnexion de votre compte Discord"])},
    "/id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vous montre l'ID de votre propre joueur"])},
    "/playtime": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pour vérifier votre temps de jeu"])},
    "/vote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avec cela, vous pouvez voter pour notre serveur et obtenir une récompense."])},
    "/fix dynamx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisez cette commande si les véhicules ou les objets ne s'affichent pas correctement"])},
    "/fix skin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Corrige les erreurs visuelles sur tous les skins"])},
    "/online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Affiche le nombre de joueurs sur le réseau ou sur le serveur actuel"])}
  },
  "crimeminigames": [
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Labyrinth"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Minigame Labyrinthe"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guidez le trait bleu à travers le labyrinthe jusqu'à la case rouge avec les touches fléchées. Le trait se déplace en continu et vous devez activement le diriger dans les passages noirs libres. Si vous touchez un mur gris, vous perdez une vie."])}
    },
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lockpick"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Minigame Crochetage"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un marqueur rouge tourne dans le sens des aiguilles d'une montre autour de l'anneau. Dès qu'il atteint le point bleu, appuyez sur la barre d'espace. La direction s'inverse ensuite et le point bleu apparaît à une nouvelle position. Répétez jusqu'à ce que la serrure soit crochetée. Trop lent ou manqué – et vous perdez une tentative."])}
    },
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Propangas"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Minigame Gaz Propane"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maintenez la barre d'espace / clic gauche pour pomper du gaz dans la machine – une barre bleue monte de bas en haut. Relâchez la touche dès que la barre est dans la zone verte. Si elle entre dans la zone rouge, le distributeur explose et la mission échoue."])}
    },
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["BruteForce"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Minigame Brute Force"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Des caractères tombent de haut en bas dans la grille. Lorsqu'un caractère rouge atteint la ligne rouge centrale, appuyez sur la barre d'espace / clic gauche. Un succès fait avancer la barre bleue d'une colonne vers la droite. Complétez toutes les colonnes et le hack réussit. Manquez trop de caractères rouges et le cambriolage échoue."])}
    }
  ]
}